import './form-experience.scss'
// components
import Button from '../../../atoms/button/button'
// icons
import { HappyIcon, SadIcon, SuperBadIcon, NormalIcon, GoodIcon } from '../../../atoms/icons'

const FormExperience = props => {
	const { value, action, sendData, buttonText } = props

	// render
	const faces = [
		{
			color: '#FF5555',
			icon: <SuperBadIcon />
		},
		{
			color: '#ED8B4C',
			icon: <SadIcon />
		},
		{
			color: '#F9B446',
			icon: <NormalIcon />
		},
		{
			color: '#39CF6D',
			icon: <GoodIcon />
		},
		{
			color: '#189950',
			icon: <HappyIcon />
		}
	]

	const setStyles = ({ active, color }) => {
		if (!active) return { fill: color }

		return {
			backgroundColor: '#EE2B7B',
			fill: '#fff'
		}
	}

	return (
		<section className='m-form-experience'>
			<div className='m-form-experience__buttons'>
				{faces.map((e, index) => (
					<button
						key={e.color}
						style={setStyles({ active: value === index + 1, color: e.color })}
						onClick={() => action({ value: index + 1, key: 'experienceAnswer' })}
					>
						{e.icon}
					</button>
				))}
			</div>
			{buttonText && (
				<Button
					uppercase
					disabled={!value}
					title={buttonText}
					classes='pink'
					onClick={() => sendData()}
				/>
			)}
		</section>
	)
}

export default FormExperience
